export default {

    //以太坊正式链
    1: {

        usdt: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        ghs: "0x68fc89fCb70550eeeCfEe42aFCcBEd87E52BbD85"
    },
    //Polygon正式链
    137: {

        usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
        ghs: "0xeF60354e18772eE829831fcAD7e6d1E5769c0Bd4"//无
    },
    //Polygon测试链Amoy
    80002: {
        usdt: "0xAE5ca41736d0FADB0572D7a017765DA02108eaCB",
        ghs: "0x66E7dB718644564aab8D113b621C6355d3b1b63F"
    },
    //本地测试链
    1337: {
        usdt: "0xacF75e5ef9724b4Ab8AC20676f594381fA5EBB74",
        ghs: "0x66E7dB718644564aab8D113b621C6355d3b1b63F"
    }


}
